import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const laptop: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3.25-2c-.344 0-.64-.117-.89-.36A1.23 1.23 0 0 1 2-3.25v-5.5c0-.344.117-.633.36-.875Q2.734-10 3.25-10h8.5c.344 0 .633.125.875.375q.375.361.375.875v5.5q0 .516-.375.89c-.242.243-.531.36-.875.36zM3-8.75v5.5c0 .063.023.121.078.172.05.055.11.078.172.078h8.5c.07 0 .129-.023.172-.078.05-.05.078-.11.078-.172v-5.5a.22.22 0 0 0-.078-.172A.22.22 0 0 0 11.75-9h-8.5a.24.24 0 0 0-.172.078A.2.2 0 0 0 3-8.75M13.75-1.5H15v.75q0 .316-.375.531c-.242.149-.531.219-.875.219H1.25C.906 0 .61-.07.36-.219.116-.363 0-.539 0-.75v-.75Zm-5.625.75q.124.002.125-.125Q8.249-.999 8.125-1h-1.25q-.127.001-.125.125-.001.127.125.125zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "15",
  }
};
